export const CopyCustomFieldRepository = Symbol('CopyCustomFieldRepository');
